import React, { Component, Fragment } from 'react'
import Breadcrumb from '../../common/breadcrumb';
import Swal from "sweetalert2";
import { set_auth } from "../../../reducers/Auth";
import { connect } from "react-redux";
import Switch from "react-switch";
import { Helmet } from "react-helmet";
import InfoIcon from "../../../assets/icons/info-icon-blue.svg";

export class SettingNotification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            loading: true,
            data: {},
            email_izin: true,
            email_lembur: true,
            email_kasbon: true,
            email_beban: true,
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    saveSettingNotification = () => {
        this.setState({
            loading: true,
        })

        let form = {
            email_izin: this.state.email_izin,
            email_lembur: this.state.email_lembur,
            email_kasbon: this.state.email_lembur,
            email_beban: this.state.email_beban,
        }

        this.props.request("setting-notif/update", form, 'POST')
            .then(response => {
                if (response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                    this.loadData()
                } else {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    loading: false,
                })
            });
    }

    loadData() {
        this.setState({
            loaded: false,
            loading: true
        })
        let form = {}
        this.props.request("setting-notif/list", form, 'POST')
            .then(response => {
                if (response) {
                    this.setState({
                        loaded: true,
                        email_izin: response.data.setting_n_email_izin === "true",
                        email_lembur: response.data.setting_n_email_lembur === "true",
                        email_kasbon: response.data.setting_n_email_kasbon === "true",
                        email_beban: response.data.setting_n_email_beban === "true",
                    })
                }
            })
        this.setState({
            loading: false
        })
    }

    componentDidMount() {
        this.loadData()
    }

    render() {
        if (this.props.user.user_level.level_page_limited == null || this.props.user.user_level.level_page_limited.search("Pengaturan") >= 0) {
            return (
                <Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Pengaturan Notifikasi - Presensi</title>
                        <meta name="description" content="Detail Presensi" />
                    </Helmet>
                    <Breadcrumb title="Pengaturan Notifikasi" />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div>
                                            <div>
                                                {this.state.loaded ?
                                                    <div>
                                                        <label className="header-input-basic">Pengaturan Notifikasi Pergantian Status Pengajuan Karyawan</label>
                                                        <div className="row">
                                                            <label className='form-label label-input-basic col-md-4 col-sm-6'>Aktifkan Notifikasi Email Pengajuan Izin/Cuti Karyawan</label>
                                                            <Switch
                                                                id={'email_izin'}
                                                                name="email_izin"
                                                                checked={this.state.email_izin}
                                                                onChange={(val) => {
                                                                    this.setState({
                                                                        email_izin: val
                                                                    })
                                                                }}
                                                                onColor="#1890ff"
                                                                offColor="#eb4034"
                                                                handleDiameter={18}
                                                                uncheckedIcon={false}
                                                                checkedIcon={false}
                                                                boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                                height={24}
                                                                width={48}
                                                                className="mr-1 switch-settings-app"
                                                            />
                                                        </div>
                                                        <div className="row">
                                                            <label className='form-label label-input-basic col-md-4 col-sm-6'>Aktifkan Notifikasi Email Pengajuan Lembur Karyawan</label>
                                                            <Switch
                                                                id={'email_lembur'}
                                                                name="email_lembur"
                                                                checked={this.state.email_lembur}
                                                                onChange={(val) => {
                                                                    this.setState({
                                                                        email_lembur: val
                                                                    })
                                                                }}
                                                                onColor="#1890ff"
                                                                offColor="#eb4034"
                                                                handleDiameter={18}
                                                                uncheckedIcon={false}
                                                                checkedIcon={false}
                                                                boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                                height={24}
                                                                width={48}
                                                                className="mr-1 switch-settings-app"
                                                            />
                                                        </div>
                                                        <div className="row">
                                                            <label className='form-label label-input-basic col-md-4 col-sm-6'>Aktifkan Notifikasi Email Pengajuan Kasbon Karyawan</label>
                                                            <Switch
                                                                id={'email_kasbon'}
                                                                name="email_kasbon"
                                                                checked={this.state.email_kasbon}
                                                                onChange={(val) => {
                                                                    this.setState({
                                                                        email_kasbon: val
                                                                    })
                                                                }}
                                                                onColor="#1890ff"
                                                                offColor="#eb4034"
                                                                handleDiameter={18}
                                                                uncheckedIcon={false}
                                                                checkedIcon={false}
                                                                boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                                height={24}
                                                                width={48}
                                                                className="mr-1 switch-settings-app"
                                                            />
                                                        </div>
                                                        <div className="row">
                                                            <label className='form-label label-input-basic col-md-4 col-sm-6'>Aktifkan Notifikasi Email Pengajuan Klaim Beban Karyawan</label>
                                                            <Switch
                                                                id={'email_beban'}
                                                                name="email_beban"
                                                                checked={this.state.email_beban}
                                                                onChange={(val) => {
                                                                    this.setState({
                                                                        email_beban: val
                                                                    })
                                                                }}
                                                                onColor="#1890ff"
                                                                offColor="#eb4034"
                                                                handleDiameter={18}
                                                                uncheckedIcon={false}
                                                                checkedIcon={false}
                                                                boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                                height={24}
                                                                width={48}
                                                                className="mr-1 switch-settings-app"
                                                            />
                                                        </div>
                                                    </div>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                        <div className="pull-right mt-4">
                                            {this.state.loading == false ?
                                                <button type="button" className="btn btn-primary" disabled={!this.state.loaded} onClick={() => {this.saveSettingNotification()}}>Simpan</button>
                                                :
                                                <button type="button" className="btn btn-primary"><i className="fa fa-refresh fa-spin" /> Loading</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <h5 className="text-center pt-4">Anda tidak punya akses ke halaman ini.</h5>
                </Fragment>
            )
        }
    }
}

const mapStateToProps = state => ({
    auth: state.Auth.auth,
    user: state.Auth.user,
    api_token: state.Auth.api_token
})

const mapDispatchToProps = dispatch => ({
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(SettingNotification)
